import { render, staticRenderFns } from "./SmsAuth.vue?vue&type=template&id=b5050346&scoped=true"
import script from "./SmsAuth.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmsAuth.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SmsAuth.vue?vue&type=style&index=0&id=b5050346&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5050346",
  null
  
)

export default component.exports